// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCommonLoadingOverlay } from "@hardwoods/App/Handlers/XNG/Common";
import { CustomAppState } from "@hardwoods/App/Store/Reducers";
import { getCommon } from "@hardwoods/App/Store/Selectors/CommonState";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { getProp } from "@insite/mobius/utilities";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => {
    return {
        isErrorModalOpen: state.context.isErrorModalOpen,
        pages: state.data.pages,
        xLoadingOverlay: getCommon(state).loadingOverlay,
        isSigningIn: state.context.isSigningIn || state.pages.signIn.isSigningInAsGuest,
    };
};

const mapDispatchToProps = {
    xCommonLoadingOverlay,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const XngLoadingOverlay: FC<Props> = ({
    isErrorModalOpen,
    pages,
    xLoadingOverlay,
    xCommonLoadingOverlay,
    isSigningIn,
}) => {
    // to solve Server side rendering issue with fields
    const [isFinishRender, setIsFinishRender] = useState(false);

    useEffect(() => {
        setIsFinishRender(true);
    }, []);

    // To close LoadingOverlay when the page redirect to another path
    useEffect(() => {
        xCommonLoadingOverlay({ type: "clear", value: "" });
    }, [pages.location]);

    // To close LoadingOverlay when ErrorModal open
    useEffect(() => {
        if (isErrorModalOpen) {
            xCommonLoadingOverlay({ type: "clear", value: "" });
        }
    }, [isErrorModalOpen]);

    const showLoading = isSigningIn || xLoadingOverlay?.length > 0 || !isFinishRender;

    return (
        <>
            {showLoading && (
                <LoadingOverlay
                    data-test-selector="global-loadingOverlay"
                    loading={showLoading}
                    css={css`
                        width: 100%;
                        position: fixed;
                        height: 100%;
                        z-index: ${getProp("theme.zIndex.loadingOverlay")};
                        top: 0;
                        bottom: 0;
                        & ~ * {
                            svg[class^="LoadingSpinnerStyle"],
                            div[class^="LoadingOverlayStyle"] {
                                display: none;
                            }
                        }
                        @media print {
                            display: none;
                        }
                    `}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(XngLoadingOverlay);
